import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.0673 49.5955C26.1752 52.4717 30.9483 54 35.8232 54C40.698 54 45.4711 52.4717 49.579 49.5955C53.6869 46.7193 57.9517 40.8473 60 36H55.5218C53.7814 40.1187 51.0019 43.6059 47.5114 46.0498C44.021 48.4936 39.9653 49.7922 35.8232 49.7922C31.6811 49.7922 27.6254 48.4936 24.1349 46.0498C20.6445 43.6059 17.865 40.1187 16.1246 36H12C14.0483 40.8473 17.9595 46.7193 22.0673 49.5955Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.0673 22.4045C26.1752 19.5283 30.9483 18 35.8232 18C40.698 18 45.4711 19.5283 49.579 22.4045C53.6869 25.2807 57.9517 31.1527 60 36H55.5218C53.7814 31.8813 51.0019 28.3941 47.5114 25.9502C44.021 23.5064 39.9653 22.2078 35.8232 22.2078C31.6811 22.2078 27.6254 23.5064 24.1349 25.9502C20.6445 28.3941 17.865 31.8813 16.1246 36H12C14.0483 31.1527 17.9595 25.2807 22.0673 22.4045Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36 31.8478C33.7068 31.8478 31.8478 33.7068 31.8478 36C31.8478 38.2932 33.7068 40.1522 36 40.1522C38.2932 40.1522 40.1522 38.2932 40.1522 36C40.1522 33.7068 38.2932 31.8478 36 31.8478ZM28 36C28 31.5817 31.5817 28 36 28C40.4183 28 44 31.5817 44 36C44 40.4183 40.4183 44 36 44C31.5817 44 28 40.4183 28 36Z",
			fill: "currentColor"
		})
	]
});
export default SvgShow;
